export * from './image-card.component';


// WEBPACK FOOTER //
// ./src/app/content/shared/components/image-card/index.ts